import { createI18n } from 'vue-i18n'
import translations from 'translations'

function getPrimaryLanguageSubtag (langCode) {
    return langCode.split(/[-_]/)[0]
}

function getBrowserLanguage () {
    return navigator.languages?.[0] ?? navigator.language ?? navigator.browserLanguage ?? navigator.userLanguage
}

function normalizeLanguageCode (langCode) {
    return getPrimaryLanguageSubtag(langCode ?? getBrowserLanguage())
}

const documentLangAttr = document.documentElement.getAttribute('lang')
const normalizedLang = normalizeLanguageCode(documentLangAttr)

const i18n = createI18n({
    locale: normalizedLang,
    fallbackLocale: 'fr',
    messages: translations
})

export default i18n
